
import { useState, useEffect } from 'react';
import axios from 'axios';
import { READ_EXPORT_SHIPMENT } from '../../../../services/apiRoutes';

export const useExportShipmentDetails = (exportShipmentId) => {
    const [shipmentDetails, setShipmentDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchShipmentDetails = async () => {
            const authToken = sessionStorage.getItem('accessToken');

            try {
                const response = await axios.get(READ_EXPORT_SHIPMENT(exportShipmentId), {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    }
                });
                setShipmentDetails(response.data.shipment);
            } catch (err) {
                console.error('Error fetching shipment details:', err);
                setError('Failed to fetch shipment details. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        if (exportShipmentId) {
            fetchShipmentDetails();
        }
    }, [exportShipmentId]);

    return { shipmentDetails, loading, error };
};



